// // Library methods
import { useTranslation } from "react-i18next";
import React, { memo } from "react";

// MUI Components
import { Grid, Typography, Box } from "@mui/material";
import DefaultModal from "../DefaultModal";
import {
  displayAsPercentage,
  toHumanReadable,
} from "../../../utils/externalReportsHelper";

const ExternalExamDetailsModal = ({
  openModal = false,
  handleClose,
  examDetails,
}) => {
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={openModal}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose(event.target.value);
        }
      }}
      title={t("external_exam_header")}
      maxWidth="sm"
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        <Box display="flex" gap="8px">
          <Typography textTransform="capitalize" fontWeight="bold">
            {t("external_exam_details_machine_source")}:
          </Typography>
          <Typography>{examDetails?.machineSource}</Typography>
        </Box>

        <Box display="flex" flexDirection="column" gap="8px">
          <Typography textTransform="capitalize" fontWeight="bold">
            {t("reliability_indices")}
          </Typography>
          <Box
            display="flex"
            sx={{
              border: "1px solid black",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <Grid
              container
              item
              xs={6}
              display="flex"
              flexDirection="column"
              gap="20px"
            >
              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("false_positive")}:
                </Typography>
                <Typography>
                  {displayAsPercentage(examDetails?.falsePositive)}
                </Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("fixation_loss")}:
                </Typography>
                <Typography>
                  {displayAsPercentage(examDetails?.fixationLoss)}
                </Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_fixation")}:
                </Typography>
                <Typography>{examDetails?.fixationValue}</Typography>
              </Box>
            </Grid>
            <Grid
              container
              item
              xs={6}
              display="flex"
              flexDirection="column"
              gap="20px"
            >
              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("false_negative")}:
                </Typography>
                <Typography>
                  {displayAsPercentage(examDetails?.falseNegative)}
                </Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_fixation_method")}:
                </Typography>
                <Typography>
                  {toHumanReadable(examDetails?.fixationMethod)}
                </Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_stimulus_size")}:
                </Typography>
                <Typography>{examDetails?.stimulusSize}</Typography>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box display="flex" flexDirection="column" gap="8px">
          <Typography textTransform="capitalize" fontWeight="bold">
            {t("vision_indices")}
          </Typography>
          <Box
            display="flex"
            sx={{
              border: "1px solid black",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <Grid
              container
              item
              xs={6}
              display="flex"
              flexDirection="column"
              gap="20px"
            >
              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_MD")}:
                </Typography>
                <Typography>{examDetails?.meanDeviation}</Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_VFI")}:
                </Typography>
                <Typography>
                  {displayAsPercentage(examDetails?.visualFieldIndex)}
                </Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_FoveaDb")}:
                </Typography>
                <Typography>{examDetails?.foveaDb}</Typography>
              </Box>
            </Grid>

            <Grid
              container
              item
              xs={6}
              display="flex"
              flexDirection="column"
              gap="20px"
            >
              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_PSD")}:
                </Typography>
                <Typography>{examDetails?.patternStandardDeviation}</Typography>
              </Box>

              <Box display="flex" gap="8px">
                <Typography textTransform="capitalize" fontWeight="bold">
                  {t("external_exam_details_GHT")}:
                </Typography>
                <Typography>
                  {toHumanReadable(examDetails?.glaucomaHemifieldTest)}
                </Typography>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </DefaultModal>
  );
};

export default memo(ExternalExamDetailsModal);
